import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import vueScrollto from 'vue-scrollto';

Vue.use(vueScrollto);
Vue.use(Vuetify, {
  iconfont: 'md',
});
